import moment from "jalali-moment";
import { toFarsiRelativeTime } from "../../../shared/utils/dateUtils";

// "3 days ago" in the active language ("-" when the date is missing)
export const formatRelativeTime = (date: string | undefined, lang: string): string => {
    if (!date) return "-";
    return lang === "fa" ? toFarsiRelativeTime(date) : moment(date).fromNow();
};